var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7188 19.0469C25.4688 20.3594 24.5312 22 22.9844 22H2.96875C1.42188 22 0.484375 20.3594 1.23438 19.0469L11.2656 1.98438C12.0156 0.671875 13.9375 0.671875 14.7344 1.98438L24.7188 19.0469ZM11.875 7.375V13.375C11.875 14.0312 12.4375 14.5 13 14.5C13.6094 14.5 14.125 14.0312 14.125 13.375V7.375C14.125 6.76562 13.6094 6.25 13 6.25C12.3438 6.25 11.875 6.76562 11.875 7.375ZM13 19C13.7969 19 14.4531 18.3438 14.4531 17.5469C14.4531 16.75 13.7969 16.0938 13 16.0938C12.1562 16.0938 11.5 16.75 11.5 17.5469C11.5 18.3438 12.1562 19 13 19Z",
    fill: "#B87F01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.f89c774e4c278f2f2b8c23c225ce2d84.svg";
export { ForwardRef as ReactComponent };